import { createAction, createAsyncActions } from "utils/context";
import * as constants from "./constants";

export const AUTH_ACTIONS = {
  login: createAsyncActions(constants.LOGIN),
  logout: createAction(constants.LOGOUT),
  updateUserData: createAction(constants.UPDATE_USER_DATA),
};
